<template>
	<keep-alive>
		<follow-map v-if="currentView == 'map'" />
		<div v-else-if="currentView == 'graph'">Graph</div>
		<follow-table v-else-if="currentView == 'table'" />
	</keep-alive>
</template>

<script>
import Vuex from 'vuex'

import FollowMap from '../components/Map'
import FollowTable from '../components/Table'

export default {
	name: "Tokens",
	
	components: {
		FollowMap,
		FollowTable
	},
	
	computed: {
		currentView () {
			return this.$store.state.viewData.currentView;
		}
	}
}
</script>
